import { useEffect, useRef } from "react";
import "./flip-wiggle.css";

const FlipListItem = ({ index, children }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const node = cardRef.current;
    if (!node) return;

    const timeout = setTimeout(() => {
      node.classList.add("flip-card");
    }, index * 100);

    return () => clearTimeout(timeout);
  }, [index]);

  return (
    <div className="flip-wrapper">
      <div ref={cardRef}>
        <div className="flip-content d-flex align-items-center justify-content-between">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FlipListItem;
